import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
  productDetails: [],
  planDetails: [],
  billPlanList: [],
  billPlanOrderList: [],
  notificationDetails: [],

  voucherDetails: [],

  ordersPermission: [],
  ordersList: [],
  invoicesPermission: [],
  invoicesPayPermission: [],

  scheduledRenewalsPermission: [],
  scheduledRenewalsList: [],

  subUsersPermission: [],
  subUsersList: [],

  userLogsList: [],
  userLogsPermission: [],

  eventLogsPermission: [],
  eventLogsList: [],

  smsLogsList: [],
  smsLogsPermission: [],

  emailLogsList: [],
  emailLogsPermission: [],

  paymentLogsList: [],
  paymentLogsPermission: [],

  userRenewalLogsList: [],
  userRenewalLogsPermission: [],

  userPlanHistoryList: [],
  userPlanHistoryPermission: [],

  userFupHistoryList: [],
  userFupHistoryPermission: [],

  userFupFilterList: [],
  userFupFilterPermission: [],

  userStaticIpBillingPermission: [],
  userStaticIpBillingList: [],

  completedUserSessionsPermission: [],
  completedUserSessionsList: [],

  sessionsDayWisePermission: [],
  sessionsDayWiseList: [],

  userIptvBillingList: [],
  userIptvBillingPermission: [],

  userVoicePhoneBillingList: [],
  userVoicePhoneBillingPermission: [],

  userOttBillingList: [],
  userOttBillingPermission: [],

  allPinsPermission: [],
  allPinsList: [],

  voucherPermission: [],
  gracePeriodPermission: [],
  payLaterUsersPermission: [],
  voucherList: [],

  pinBillingPermission: [],
  pinBillingList: [],

  invoicesList: [],
  proformaInvoicesList: [],
  creditNotesList: [],
  gracePeriodList: [],
  staticIpsBillingList: [],
  proformaInvoicesPermission: [],
  staticIpsBillingPermission: [],
  creditNotesPermission: [],
  paymentsPermission: [],
  paymentsList: [],
  invoicesPayList: [],
  payLaterUsersList: [],
  renewalSummaryList: [],
  billPlanProductCategoriesList: [],
  billPlanProductsList: [],
  billPlanPeriodsList: [],
  billPlanPermissionList: [],
  billingConfigList: [],
  billingConfigPermission: [],
  invoiceTemplateList: [],
  receiptTemplateList: [],
  creditNoteTemplateList: [],
  cafTemplateList: [],
  franchiseInvoiceTemplateList: [],
  invoiceDashboard: [],
  paymentDashboard: [],
  pinPunchGroupPermission: [],
  pinPunchGroupList: [],
  pinPunchViewPermission: [],
  pinPunchViewList: [],
  deleteOrderLinePercentage: "",
  replaceOrderLinePercentage: "",
  deletenOrderLinePercentage: "",
  addOrderPercentage: "",
  invoicePaidPercent: "",
  updateOrderLinePercentage: ""
}

const mutations = {
  CLEAR_PRODUCT_STATE(state) {
    state.productDetails = [];
    state.ordersPermission = [];
    state.ordersList = [];
    state.invoicesPermission = [];
    state.invoicesPayPermission = [];
    state.invoicesList = [];
    state.proformaInvoicesList = [];
    state.creditNotesList = [];
    state.gracePeriodList = [];
  },
  CLEAR_PLAN_STATE(state) {
    state.planDetails = [];
    state.billPlanList = [];
    state.billPlanOrderList = [];
    state.billPlanProductCategoriesList = [];
    state.billPlanProductsList = [];
    state.billPlanPeriodsList = [];
    state.billPlanPermissionList = [];
  },
  CLEAR_ORDER_STATE(state) {
    state.ordersList = [];
    state.ordersPermission = [];
  },
  CLEAR_PAYMENT_STATE(state) {
    state.paymentsPermission = [];
    state.paymentsList = [];
    state.invoicesPayList = [];
  },
  CLEAR_BILLING_STATE(state) {
    state.ordersList = [];
    state.ordersPermission = [];
    state.invoicesPermission = [];
    state.invoicesPayPermission = [];
    state.scheduledRenewalsPermission = [];
    state.scheduledRenewalsList = [];
    state.invoicesList = [];
    state.invoicesPayList = [];
    state.renewalSummaryList = [];
    state.notificationDetails = [];
    state.invoiceTemplateList = [];
    state.receiptTemplateList = [];
    state.creditNoteTemplateList = [];
    state.cafTemplateList = [];
    state.franchiseInvoiceTemplateList = [];
  },
  CLEAR_PAY_AS_YOU_GO_USER_STATE(state) {
    state.voucherList = [];
  },
  SET_FAILURE(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'error',
      text: error
    });
  },
  SET_PIN_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.pinBillingPermission = userData.permissions;
    state.pinBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-pinBillingList'] = parseData;
      state.pinBillingList = tData;
    }
  },
  SET_PIN_BILLING_DETAIL_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.pinBillingDetailPermission = userData.permissions;
    state.pinBillingDetailList = [];
    if (parseData != null) {
      tData[userData.accountId + '-pinBillingDetailList'] = parseData;
      state.pinBillingDetailList = tData;
    }
  },
  SET_PRODUCT_DETAILS(state, productDetails) {
    var tData = {};
    var parseData = productDetails.message;
    if (Object.keys(state.productDetails).length == 0) {
      tData[productDetails.accountId + '-productList'] = parseData;
      state.productDetails = tData;
    } else {
      Vue.set(state.productDetails, productDetails.accountId + '-productList', parseData);
    }
  },

  ADD_PRODUCT_LIST(state, data) {
    var productData = JSON.parse(data.productdata);
    var accountId = data.accountId;
    if (Object.keys(state.productDetails).length != 0 && state.productDetails != 'noData') {
      if (state.productDetails != 'noData' && productData.length > 0) {
        for (var i = 0; i < productData.length; i++) {
          var index = state.productDetails[accountId + "-productList"].products.findIndex(product => product.id == productData[i].id);
          if (index != '-1') {
            state.productDetails[accountId + "-productList"].products.splice(index, 1)
          }
          state.productDetails[accountId + "-productList"].products.push(productData[i]);
        }
      }
    } else {
      var dataSet = {}
      dataSet[accountId + "-productList"].products = productData;
      state.productDetails = dataSet;
    }
  },
  CHANGE_BALACE_VALUE(state, data) {
    var userId = data.userId;
    var value = data.value;
    var accountId = data.accountId;
    for (var i = 0; i < state.voucherList[accountId + '-voucherList'].length; i++) {
      if (state.voucherList[accountId + '-voucherList'][i].User.id == userId) {
        state.voucherList[accountId + '-voucherList'][i].ContactSetting3.accountBalanceCheck = value.reason;
      }
    }
    state.voucherList = state.voucherList;
  },

  ADD_PRODUCT_CATEGORY_LIST(state, data) {
    var productData = JSON.parse(data.productdata);
    var accountId = data.accountId;
    if (productData.length > 0) {
      for (var i = 0; i < productData.length; i++) {
        var index = state.productDetails[accountId + '-productList'].productCategories.findIndex(productCat => productCat.ItemType.id == productData[i].ItemType.id);
        if (index != '-1') {
          state.productDetails[accountId + '-productList'].productCategories.splice(index, 1)
        }
        state.productDetails[accountId + '-productList'].productCategories.push(productData[i]);
      }
    }
  },
  DELETE_PRODUCT_LIST(state, data) {
    var productIds = data.productIds;
    var productCategoryIds = data.productCategoryIds;
    var accountId = data.accountId;

    if (Object.keys(state.productDetails).length != 0) {
      for (var i = 0; i < productIds.length; i++) {
        var index = state.productDetails[accountId + "-productList"].products.findIndex(product => product.id == productIds[i]);
        state.productDetails[accountId + "-productList"].products.splice(index, 1)
      }
    }

    if (productCategoryIds != undefined && productCategoryIds.length > 0) {
      for (var i = 0; i < productCategoryIds.length; i++) {
        var index = state.productDetails[accountId + '-productList'].productCategories.findIndex(produtCat => produtCat.ItemType.id == productCategoryIds[i]);
        if (index != '-1') {
          state.productDetails[accountId + '-productList'].productCategories.splice(index, 1);
        }
      }
    }
  },
  SET_USER_STATIC_IP_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userStaticIpBillingPermission = userData.permissions;
    state.userStaticIpBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userStaticIpBillingList'] = parseData;
      state.userStaticIpBillingList = tData;
    }
  },
  SET_ALL_PINS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.allPinsPermission = userData.permissions;
    state.allPinsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-allPinsList'] = parseData;
      state.allPinsList = tData;
    }
  },
  SET_USER_IPTV_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userIptvBillingPermission = userData.permissions;
    state.userIptvBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userIptvBillingList'] = parseData;
      state.userIptvBillingList = tData;
    }
  },
  SET_USER_VOICE_PHONE_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userVoicePhoneBillingPermission = userData.permissions;
    state.userVoicePhoneBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userVoicePhoneBillingList'] = parseData;
      state.userVoicePhoneBillingList = tData;
    }
  },
  SET_USER_OTT_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userOttBillingPermission = userData.permissions;
    state.userOttBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userOttBillingList'] = parseData;
      state.userOttBillingList = tData;
    }
  },
  SET_SUB_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.subUsersPermission = userData.permissions;
    state.subUsersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-subUsersList'] = parseData;
      state.subUsersList = tData;
    }
  },
  SET_ORDER_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.ordersPermission = userData.permissions;
    state.ordersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-ordersList'] = parseData;
      state.ordersList = tData;
    }
  },
  SET_USER_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userLogsPermission = userData.permissions;
    state.userLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userLogsList'] = parseData;
      state.userLogsList = tData;
    }
  },
  SET_Event_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.eventLogsPermission = userData.permissions;
    state.eventLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-eventLogsList'] = parseData;
      state.eventLogsList = tData;
    }
  },
  SET_SMS_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.smsLogsPermission = userData.permissions;
    state.smsLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-smsLogsList'] = parseData;
      state.smsLogsList = tData;
    }
  },
  SET_EMAIL_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.emailLogsPermission = userData.permissions;
    state.emailLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-emailLogsList'] = parseData;
      state.emailLogsList = tData;
    }
  },
  SET_PAYMENT_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.paymentLogsPermission = userData.permissions;
    state.paymentLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-paymentLogsList'] = parseData;
      state.paymentLogsList = tData;
    }
  },
  SET_USER_RENEWAL_LOGS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userRenewalLogsPermission = userData.permissions;
    state.userRenewalLogsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userRenewalLogsList'] = parseData;
      state.userRenewalLogsList = tData;
    }
  },
  SET_USER_PLAN_HISTORY_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userPlanHistoryPermission = userData.permissions;
    state.userPlanHistoryList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userPlanHistoryList'] = parseData;
      state.userPlanHistoryList = tData;
    }
  },
  SET_USER_FUP_HISTORY_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.userFupHistoryPermission = userData.permissions;
    state.userFupHistoryList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userFupHistoryList'] = parseData;
      state.userFupHistoryList = tData;
    }
  },
  SET_USER_FUP_FILTERS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.userFupFilterPermission = userData.permissions;
    state.userFupFilterList = [];
    if (parseData != null) {
      tData[userData.accountId + '-fupFiltersList'] = parseData;
      state.userFupFilterList = tData;
    }
  },
  SET_COMPLETED_USER_SESSIONS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.completedUserSessionsPermission = userData.permissions;
    state.completedUserSessionsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-completedUserSessionsList'] = parseData;
      state.completedUserSessionsList = tData;
    }
  },
  SET_USER_TRAFFIC_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.sessionsDayWisePermission = userData.permissions;
    state.sessionsDayWiseList = [];
    if (parseData != null) {
      tData[userData.accountId + '-userTrafficList'] = parseData;
      state.sessionsDayWiseList = tData;
    }
  },
  DELETE_ORDER_LIST(state, data) {
    var orderIds = data.orderIds;
    var accountId = data.accountId;

    if (Object.keys(state.ordersList).length != 0) {
      for (var i = 0; i < orderIds.length; i++) {
        var index = state.ordersList[accountId + "-ordersList"].findIndex(order => order.PurchaseOrder.id == orderIds[i]);
        state.ordersList[accountId + "-ordersList"].splice(index, 1)
      }
    }
  },
  UPDATE_USER_STATIC_IP_LIST(state, data) {
    var staticIpDetails = data.staticIpDetails;
    var account = data.accountId;
    state.userStaticIpBillingList[account + "-userStaticIpBillingList"].staticIpsArr = staticIpDetails;

  },
  UPDATE_ORDER_LIST(state, data) {
    var orderData = JSON.parse(data.orderData);
    var accountId = orderData.accountId;
    var account = data.accountId;
    var type = data.type;
    console.log("state", state);
    console.log("orderData", orderData);
    if (type == "Generate Invoice From Order") {
      if (Object.keys(state.ordersList).length != 0 && state.ordersList != 'noData') {
        if (orderData[0].PurchaseOrder.id != undefined || orderData[0].PurchaseOrder.id != null || orderData[0].PurchaseOrder.id != "") {
          console.log("order", order);
          var index1 = state.ordersList[account + "-ordersList"].findIndex(order => order.PurchaseOrder.id == orderData[0].PurchaseOrder.id);
          console.log("index1", index1);
          if (index1 != '-1') {
            state.ordersList[account + "-ordersList"][index1].PurchaseOrder.status_id = orderData[0].PurchaseOrder.status_id;
            return;
          }
        }
      }
    }

    if (Object.keys(state.ordersList).length != 0 && state.ordersList != 'noData') {
      console.log("asdfghjksdfgh");
      if (orderData.id != undefined || orderData.id != null || orderData.id != "") {
        //  console.log("order",order.PurchaseOrder.id);
        console.log("order1", account);
        console.log("order2", state.ordersList[account + "-ordersList"]);
        // var temp =JSON.parse(state.ordersList);
        var index = state.ordersList[account + "-ordersList"].findIndex(order => order.PurchaseOrder.id == orderData.id);
        // state.ordersList[account + "-ordersList"] = JSON.stringify(temp);

        console.log("qwerty", state.ordersList[account + "-ordersList"]);
        if (index != '-1') {
          if (type == "Customer Order Number") {
            state.ordersList[account + "-ordersList"][index].PurchaseOrder.customer_order_number = orderData.customer_order_number;
          } else if (type == "Customer Order Date") {
            state.ordersList[account + "-ordersList"][index].PurchaseOrder.customer_order_date = orderData.customer_order_date;
          } else if (type == "Billing Cycle") {
            state.ordersList[account + "-ordersList"][index].PurchaseOrder.due_date_value = orderData.due_date_value;
            state.ordersList[account + "-ordersList"][index].PurchaseOrder.due_date_unit_id = orderData.due_date_unit_id;
          }
        }
      }
      state.ordersList = state.ordersList;
    }
  },
  UPDATE_INVOICEPAY_LIST(state, data) {
    var invoicePayData = JSON.parse(data.invoicePayData);
    var accountId = invoicePayData.accountId;
    var type = data.type;
    if (Object.keys(state.invoicesPayList).length != 0 && state.invoicesPayList != 'noData') {
      if (invoicePayData.id != undefined || invoicePayData.id != null || invoicePayData.id != "") {
        var index = state.invoicesPayList[accountId + "-invoicesPayList"].findIndex(invoice => invoice.Invoice.id == invoicePayData.id);
        if (index != '-1') {
          if (type == "Change Invoice Numbers") {
            state.invoicesPayList[accountId + "-invoicesPayList"][index].Invoice.public_number = invoicePayData.public_number;
          } else if (type == "Created Date") {
            state.invoicesPayList[accountId + "-invoicesPayList"][index].Invoice.create_datetime = invoicePayData.create_datetime;
          }
        }
      }
      state.invoicesPayList = state.invoicesPayList;
    }
  },
  UPDATE_INVOICE_LIST(state, data) {
    var invoicePayData = data.invoicePayData;
    var accountId = invoicePayData.accountId;
    var type = data.type;
    if (Object.keys(state.invoicesList).length != 0 && state.invoicesList != 'noData') {
      if (invoicePayData.id != undefined || invoicePayData.id != null || invoicePayData.id != "") {
        var index = state.invoicesList[accountId + "-invoicesList"].findIndex(invoice => invoice.Invoice.id == invoicePayData.id);
        if (index != '-1') {
          if (type == "Change Invoice Numbers") {
            state.invoicesList[accountId + "-invoicesList"][index].Invoice.public_number = invoicePayData.public_number;
          } else if (type == "Created Date") {
            state.invoicesList[accountId + "-invoicesList"][index].Invoice.create_datetime = invoicePayData.create_datetime;
          } else if (type == "Change Po Numbers") {
            state.invoicesList[accountId + "-invoicesList"][index].Invoice.po_number = invoicePayData.po_number;
          }
        }
      }
      state.invoicesPayList = state.invoicesPayList;
    }
  },
  UPDATE_SINGLE_ORDER_LIST(state, data) {
    var orderData = JSON.parse(data.orderdata);
    var accountId = data.accountId;
    var type = data.type;
    if (Object.keys(state.ordersList).length != 0 && state.ordersList != 'noData' && orderData.length > 0) {
      var index = state.ordersList[accountId + "-ordersList"].findIndex(order => order.PurchaseOrder.id == orderData[0].PurchaseOrder.id);
      if (index != '-1') {
        state.ordersList[accountId + "-ordersList"].splice(index, 1, orderData[0]);
      } else {
        state.ordersList[accountId + "-ordersList"].unshift(orderData[0]);
      }
    }
  },
  SET_PROFORMA_INVOICE_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.proformaInvoicesPermission = userData.permissions;
    state.proformaInvoicesList = [];
    if (parseData != null) {
      tData[userData.accountId + '-proformaInvoicesList'] = parseData;
      state.proformaInvoicesList = tData;
    }
  },
  SET_INVOICE_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.invoicesPermission = userData.permissions;
    state.invoicesList = [];
    if (parseData != null) {
      tData[userData.accountId + '-invoicesList'] = parseData;
      state.invoicesList = tData;
    }
  },
  SET_VOUCHER_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.voucherPermission = userData.permissions;
    state.voucherList = [];
    if (parseData != null) {
      tData[userData.accountId + '-voucherList'] = parseData;
      state.voucherList = tData;
    }

  },
  SET_GRACE_PERIOD_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.gracePeriodPermission = userData.permissions;
    state.gracePeriodList = [];
    if (parseData != null) {
      tData[userData.accountId + '-gracePeriodList'] = parseData;
      state.gracePeriodList = tData;
    }
  },
  SET_PAY_LATER_USERS_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.payLaterUsersPermission = userData.permissions;
    state.payLaterUsersList = [];
    if (parseData != null) {
      tData[userData.accountId + '-payLaterUsersList'] = parseData;
      state.payLaterUsersList = tData;
    }
  },
  SET_STATIC_IPS_BILLING_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.staticIpsBillingPermission = userData.permissions;
    state.staticIpsBillingList = [];
    if (parseData != null) {
      tData[userData.accountId + '-staticIpsBillingList'] = parseData;
      state.staticIpsBillingList = tData;
    }
  },
  SET_PIN_BUNCH_VIEW_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.pinPunchViewPermission = userData.permissions;
    state.pinBunchViewList = [];
    if (parseData != null) {
      tData[userData.accountId + '-pinBunchViewList'] = parseData;
      state.pinPunchViewList = tData;
    }
  },
  SET_PIN_BUNCH_GROUP_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.pinPunchGroupPermission = userData.permissions;
    state.pinPunchGroupList = [];
    if (parseData != null) {
      tData[userData.accountId + '-pinBunchGroupList'] = parseData;
      state.pinPunchGroupList = tData;
    }
  },
  SET_CREDIT_NOTES_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.creditNotesPermission = userData.permissions;
    state.creditNotesList = [];
    if (parseData != null) {
      tData[userData.accountId + '-creditNotesList'] = parseData;
      state.creditNotesList = tData;
    }
  },
  UPDATE_CREDIT_NOTE_LIST(state, data) {
    var invoicePayData = data.creNumData;
    var accountId = invoicePayData.accountId;
    var type = data.type;
    if (Object.keys(state.creditNotesList).length != 0 && state.creditNotesList != 'noData') {
      if (invoicePayData.id != undefined || invoicePayData.id != null || invoicePayData.id != "") {
        var index = state.creditNotesList[accountId + "-creditNotesList"].findIndex(invoice => invoice.CreditNote.id == invoicePayData.id);
        if (index != '-1') {
          if (type == "Change CreditNote Numbers") {
            state.creditNotesList[accountId + "-creditNotesList"][index].CreditNote.public_number = invoicePayData.public_number;
          }
        }
      }
      state.creditNotesList = state.creditNotesList;
    }
  },
  SET_INVOICE_PAY_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.invoicesPayPermission = userData.permissions;
    state.invoicesPayList = [];
    if (parseData != null) {
      tData[userData.accountId + '-invoicesPayList'] = parseData;
      state.invoicesPayList = tData;
    }
  },
  SET_SCHEDULED_RENEWALS_LIST(state, userData) {
    var tData = {};
    var parseData = null;
    if (userData != undefined && userData.message != undefined) {
      parseData = JSON.parse(userData.message);
    }
    if (userData != undefined && userData.permissions != undefined) {
      state.scheduledRenewalsPermission = userData.permissions;
    }
    state.scheduledRenewalsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-scheduledRenewalsList'] = parseData;
      state.scheduledRenewalsList = tData;
    }
  },
  SET_RENEWAL_SUMMARY_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.renewalSummaryList = [];
    if (parseData != null) {
      tData[userData.accountId + '-renewalSummaryList'] = parseData;
      state.renewalSummaryList = tData;
    }
  },
  SET_BILLING_CONFIG_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.billingConfigPermission = userData.permissions;
    state.billingConfigList = [];
    if (parseData != null) {
      tData[userData.accountId + '-billingConfigList'] = parseData;
      state.billingConfigList = tData;
    }
  },

  UPDATE_SCHEDULED_RENEWALS_LIST(state, data) {
    var execId = JSON.parse(data.execId);
    var accountId = data.accountId;
    if (Object.keys(state.scheduledRenewalsList).length != 0 && state.scheduledRenewalsList != 'noData' && execId.length > 0) {
      for (var i = 0; i < execId.length; i++) {
        var index = state.scheduledRenewalsList[accountId + "-scheduledRenewalsList"].findIndex(invoice => invoice.Invoice.id == execId[i].Invoice.id);
        if (index != '-1') {
          state.scheduledRenewalsList[accountId + "-scheduledRenewalsList"].splice(index, 1, execId[i]);
        } else {
          state.scheduledRenewalsList[accountId + "-scheduledRenewalsList"].push(execId[i]);
        }
      }
    }
  },
  UPDATE_EXPIRY_REMOVE(state, data) {
    var userId = data.userDetails;
    var accountId = data.accountId;
    for (var i = 0; i < userId.length; i++) {
      var index = state.gracePeriodList[accountId + "-gracePeriodList"].findIndex(voucher => voucher.User.id == userId[i].User.id);
      if (index != '-1') {
        state.gracePeriodList[accountId + "-gracePeriodList"][index].User = userId[i].User;
      }
    }
  },
  CREATE_STATICIP_BILLING(state, data) {
    var userId = data.userDetails;
    var accountId = data.accountId;
    if (Object.keys(state.staticIpsBillingList).length != 0) {
      state.staticIpsBillingList[accountId + "-staticIpsBillingList"].push(userId[0]);
    }
  },
  DELETE_SCHEDULED_RENEWALS_LIST(state, data) {
    var execsId = data.execId;
    var accountId = data.accountId;

    if (Object.keys(state.scheduledRenewalsList).length != 0) {
      for (var i = 0; i < execsId.length; i++) {
        var index = state.scheduledRenewalsList[accountId + "-scheduledRenewalsList"].findIndex(sRenewal => sRenewal.ExecuteCommand.id == execsId[i]);
        state.scheduledRenewalsList[accountId + "-scheduledRenewalsList"].splice(index, 1)
      }
    }
  },
  DELETE_INVOICES_LIST(state, data) {
    var invoicesIds = data.invoiceIds;
    var accountId = data.accountId;

    if (Object.keys(state.invoicesList).length != 0) {
      for (var i = 0; i < invoicesIds.length; i++) {
        var index = state.invoicesList[accountId + "-invoicesList"].findIndex(invoice => invoice.Invoice.id == invoicesIds[i]);
        state.invoicesList[accountId + "-invoicesList"].splice(index, 1)
      }
    }
  },
  LINK_SUBUSER_LIST(state, data) {
    var message = data.message;
    var accountId = data.accountId;
    if (Object.keys(state.subUsersList).length != 0) {
      for (var i = 0; i < message.length; i++) {
        state.subUsersList[accountId + "-subUsersList"].users[i] = message[i];
      }
    }
  },

  ADD_SUBUSER_LIST(state, data) {
    var userDetails = data.userDetails;
    var accountId = data.accountId;
    if (Object.keys(state.subUsersList).length != 0) {
      state.subUsersList[accountId + "-subUsersList"].linkedUsersDetails.push(userDetails[0]);
    }
  },

  DELETE_SUBUSER_LIST(state, data) {
    var userDetails = data.userDetails;
    var accountId = data.accountId;
    if (Object.keys(state.subUsersList).length != 0) {
      for (var i = 0; i < userDetails.length; i++) {
        var index = state.subUsersList[accountId + "-subUsersList"].linkedUsersDetails.findIndex(link => link.User.id == userDetails[i].User.id);
        if (index != "-1") {
          state.subUsersList[accountId + "-subUsersList"].linkedUsersDetails.splice(index, 1);
        }

      }
    }
  },

  DELETE_PROFORMA_INVOICES_LIST(state, data) {
    var invoicesIds = data.invoiceIds;
    var accountId = data.accountId;

    if (Object.keys(state.proformaInvoicesList).length != 0) {
      for (var i = 0; i < invoicesIds.length; i++) {
        var index = state.proformaInvoicesList[accountId + "-proformaInvoicesList"].findIndex(invoice => invoice.Invoice.id == invoicesIds[i]);
        if (index != "-1") {
          state.proformaInvoicesList[accountId + "-proformaInvoicesList"].splice(index, 1);
        }
      }
    }
  },
  DELETE_CREDIT_NOTES_LIST(state, data) {
    var invoicesIds = data.invoiceIds;
    var accountId = data.accountId;

    if (Object.keys(state.creditNotesList).length != 0) {
      for (var i = 0; i < invoicesIds.length; i++) {
        var index = state.creditNotesList[accountId + "-creditNotesList"].findIndex(invoice => invoice.CreditNote.id == invoicesIds[i]);
        state.creditNotesList[accountId + "-creditNotesList"].splice(index, 1)
      }
    }
  },
  UPDATE_INVOICES_LIST(state, data) {
    var invoiceData = JSON.parse(data.invoiceData);
    var accountId = data.accountId;
    if (Object.keys(state.invoicesList).length != 0 && state.invoicesList != 'noData' && invoiceData.length > 0) {
      for (var i = 0; i < invoiceData.length; i++) {
        var index = state.invoicesList[accountId + "-invoicesList"].findIndex(invoice => invoice.Invoice.id == invoiceData[i].Invoice.id);
        if (index != '-1') {
          state.invoicesList[accountId + "-invoicesList"].splice(index, 1, invoiceData[i]);
        } else {
          state.invoicesList[accountId + "-invoicesList"].push(invoiceData[i]);
        }
      }
    }
  },
  UPDATE_STATUS_PINBUNCH(state, data) {
    var updatedPins = data.updateStatus;
    var accountId = data.accountId;
    if (updatedPins.length > 0) {
      for (var i = 0; i < updatedPins.length; i++) {
        state.pinPunchGroupList[accountId + "-pinBunchGroupList"][i].Pin.status = updatedPins[i].Pin.status;
        state.pinPunchGroupList[accountId + "-pinBunchGroupList"][i].Pin.sold_to = updatedPins[i].Pin.sold_accountId;
      }
    }
  },
  DESTROY_PIN_BUNCH(state, data) {
    var bunchId = data.bunchId;
    var accountId = data.accountId;
    var pinBunchLength = state.pinPunchGroupList[accountId + "-pinBunchGroupList"].length;
    for (var i = 0; i < pinBunchLength; i++) {
      if (state.pinPunchGroupList[accountId + "-pinBunchGroupList"][i].Pin.bunch_id == bunchId) {
        state.pinPunchGroupList[accountId + "-pinBunchGroupList"][i].Pin.status = 'deleted';
      }
    }
  },
  DELETE_PIN_BUNCH(state, data) {
    var bunchId = data.bunchId;
    var accountId = data.accountId;
    var index = state.pinPunchGroupList[accountId + "-pinBunchGroupList"].findIndex(pin => pin.Pin.bunch_id == bunchId);
    if (index != '-1') {
      state.pinPunchGroupList[accountId + "-pinBunchGroupList"].splice(index, 1)
    }

  },
  SET_PAYMENT_LIST(state, userData) {
    var tData = {};
    var parseData = JSON.parse(userData.message);
    state.paymentsPermission = userData.permissions;
    state.paymentsList = [];
    if (parseData != null) {
      tData[userData.accountId + '-paymentsList'] = parseData;
      state.paymentsList = tData;
    }
  },

  DELETE_PAYMENT_LIST(state, data) {
    var paymentIds = data.paymentIds;
    var accountId = data.accountId;
    if (Object.keys(state.paymentsList).length != 0) {
      for (var i = 0; i < paymentIds.length; i++) {
        var index = state.paymentsList[accountId + "-paymentsList"].findIndex(payment => payment.Payment.id == paymentIds[i]);
        state.paymentsList[accountId + "-paymentsList"].splice(index, 1)
      }
    }
  },
  UPDATE_PAYMENT_LIST(state, data) {
    var invoicePayData = data.invoicePayData;
    var accountId = invoicePayData.accountId;
    if (Object.keys(state.paymentsList).length != 0 && state.paymentsList != 'noData') {
      if (invoicePayData.id != undefined || invoicePayData.id != null || invoicePayData.id != "") {
        var index = state.paymentsList[accountId + "-paymentsList"].findIndex(invoice => invoice.Payment.id == invoicePayData.id);
        if (index != '-1') {
          var datetime = moment(
            invoicePayData.create_datetime,
            "YYYY-MM-DD HH:mm"
          ).format("DD-MM-YYYY HH:mm");
          state.paymentsList[accountId + "-paymentsList"][index].Payment.create_datetime = datetime;
        }
      }
      state.paymentsList = state.paymentsList;
    }
  },
  SET_PLAN_DETAILS(state, planDetails) {
    var tData = {};
    var tData1 = {};
    var tData2 = {};
    var tData3 = {};
    var tData4 = {};
    var tData5 = {};
    var tData6 = {};
    var parseData = planDetails.message;

    if (Object.keys(state.planDetails).length == 0) {
      tData[planDetails.accountId + '-planList'] = parseData;
      state.planDetails = tData;
      tData1[planDetails.accountId + '-planList'] = parseData.billPlans;
      state.billPlanList = tData1;
      tData2[planDetails.accountId + '-planList'] = parseData.tableData;
      state.billPlanOrderList = tData2;
      tData3[planDetails.accountId + '-planList'] = parseData.productCategories;
      state.billPlanProductCategoriesList = tData3;
      tData4[planDetails.accountId + '-planList'] = parseData.products;
      state.billPlanProductsList = tData4;
      tData5[planDetails.accountId + '-planList'] = parseData.periods;
      state.billPlanPeriodsList = tData5;
      tData6[planDetails.accountId + '-planList'] = parseData.permissions;
      state.billPlanPermissionList = tData6;
    } else {
      Vue.set(state.planDetails, planDetails.accountId + '-planList', parseData);
      Vue.set(state.billPlanList, planDetails.accountId + '-planList', parseData.billPlans);
      Vue.set(state.billPlanOrderList, planDetails.accountId + '-planList', parseData.tableData);
      Vue.set(state.billPlanProductCategoriesList, planDetails.accountId + '-planList', parseData.productCategories);
      Vue.set(state.billPlanProductsList, planDetails.accountId + '-planList', parseData.products);
      Vue.set(state.billPlanPeriodsList, planDetails.accountId + '-planList', parseData.periods);
      Vue.set(state.billPlanPermissionList, planDetails.accountId + '-planList', parseData.permissions);
    }
  },
  ADD_BILL_PLAN_LIST(state, data) {
    var planData = JSON.parse(data.planData);
    var accountId = data.accountId;

    if (Object.keys(state.billPlanList).length != 0 && state.billPlanList != 'noData') {
      if (state.billPlanList != 'noData' && planData.length > 0) {
        for (var i = 0; i < planData.length; i++) {
          var index = state.billPlanList[accountId + "-planList"].findIndex(plan => plan.BillPlan.id == planData[i].BillPlan.id);
          if (index != '-1') {
            state.billPlanList[accountId + "-planList"][index].BillPlan.name = planData[i].BillPlan.name;
          } else {
            state.billPlanList[accountId + "-planList"].push(planData[i]);
          }
        }
      }
    } else {
      var dataSet = {}
      dataSet[accountId + "-planList"] = planData;
      state.billPlanList = dataSet;
    }

  },
  DELETE_PLAN_LIST(state, data) {
    var planIds = data.planIds;
    var accountId = data.accountId;
    if (planIds != undefined && planIds.length > 0) {
      for (var i = 0; i < planIds.length; i++) {
        var index = state.billPlanList[accountId + '-planList'].findIndex(plan => plan.BillPlan.id == planIds[i]);
        if (index != '-1') {
          state.billPlanList[accountId + '-planList'].splice(index, 1);
        }
      }
    }
  },
  DELETE_PLAN_POLICY_LIST(state, data) {
    var planData = JSON.parse(data.planIds);
    var accountId = data.accountId;
    if (planData != undefined && planData.length > 0) {
      for (var i = 0; i < planData.length; i++) {
        var index = state.billPlanOrderList[accountId + '-planList'][0][planData[i].billPlanId].findIndex(plan => plan.id == planData[i].planIds);
        if (index != '-1') {
          state.billPlanOrderList[accountId + '-planList'][0][planData[i].billPlanId].splice(index, 1);
        }
      }
    }
  },
  ADD_PLAN_POLICY_LIST(state, data) {
    var planData = data.planData;
    var accountId = data.accountId;
    var method = data.method;
    var planId = data.planId;
    if (Object.keys(planData).length != 0) {
      if (method == 'create') {
        for (const [key, value] of Object.entries(planData)) {
          if (Object.keys(state.billPlanOrderList[accountId + '-planList'][0]).includes(key)) {
            delete (state.billPlanOrderList[accountId + '-planList'][0][key]);
          }
          state.billPlanOrderList[accountId + '-planList'][0] = planData;
        }
      }
      if (method == 'display') {
        for (const [key, value] of Object.entries(planData)) {
          if (Object.keys(state.billPlanOrderList[accountId + '-planList']).includes(key)) {
            delete (state.billPlanOrderList[accountId + '-planList'][key]);
          }
          var newObj = {};
          newObj[key] = value;
          var cprop = true;
          if (state.billPlanOrderList[accountId + '-planList'].length != 0) {
            for (var key2 in state.billPlanOrderList[accountId + '-planList']) {
              if (Object.keys(state.billPlanOrderList[accountId + '-planList'][key2]).includes(key)) {
                cprop = false;
              }
            }
          }
          if (cprop == true) {
            state.billPlanOrderList[accountId + '-planList'].push(newObj);
          }
        }
      }
    }
  },
  UPDATE_PLAN_PRODUCT_CATEGORIES(state, planDetails) {
    Vue.set(state.billPlanProductCategoriesList, planDetails.account_id + '-planList', planDetails.productCategories);
    Vue.set(state.billPlanProductsList, planDetails.account_id + '-planList', planDetails.products);
    Vue.set(state.billPlanPeriodsList, planDetails.account_id + '-planList', planDetails.periods);
  },
  SET_NOTIFICATION_DETAILS(state, notificationDetails) {
    var tData = {};
    var parseData = notificationDetails.message;
    if (Object.keys(state.notificationDetails).length == 0) {
      tData[notificationDetails.accountId + '-notificationList'] = parseData;
      state.notificationDetails = tData;
    } else {
      Vue.set(state.notificationDetails, notificationDetails.accountId + '-notificationList', parseData);
    }
  },
  SET_RESTRICTION_CHECKBOX_VALUE(state, notificationDetails) {
    if (notificationDetails.switchCheckBoxValue == 'on') {
      Vue.set(state.notificationDetails[notificationDetails.accountId + '-notificationList'], 'subAccountsCanNotChangeBillingNotifications', 'Yes');
    } else {
      Vue.set(state.notificationDetails[notificationDetails.accountId + '-notificationList'], 'subAccountsCanNotChangeBillingNotifications', 'No');
    }
  },
  SET_INVOICE_TEMPLATE_DETAILS(state, invoiceTemplateData) {
    var tData = {};
    var parseData = invoiceTemplateData.message;
    if (Object.keys(state.invoiceTemplateList).length == 0) {
      tData[invoiceTemplateData.accountId + '-invoiceTemplateList'] = parseData;
      state.invoiceTemplateList = tData;
    } else {
      Vue.set(state.invoiceTemplateList, invoiceTemplateData.accountId + '-invoiceTemplateList', parseData);
    }
  },
  ADD_EDIT_INVOICE_TEMPLATE_LIST(state, data) {
    var templates = data.templates;
    var accountId = data.accountId;
    Vue.set(state.invoiceTemplateList[accountId + '-invoiceTemplateList'], 'templates', templates);
  },
  DELETE_INVOICE_TEMPLATE_LIST(state, data) {
    var invoiceTemplateName = data.invoiceData;
    var accountId = data.accountId;
    if (Object.keys(state.invoiceTemplateList).length != 0) {
      var index = state.invoiceTemplateList[accountId + "-invoiceTemplateList"].templates.findIndex(invoiceTemplate => invoiceTemplate.invoiceTemplateName == invoiceTemplateName);
      if (index != '-1') {
        state.invoiceTemplateList[accountId + "-invoiceTemplateList"].templates.splice(index, 1)
      }
    }
  },
  SET_TEMPLATE_CHECKBOX_VALUE(state, templateData) {
    var accountId = templateData.accountId;
    if (templateData.type == 'invoice_template') {
      if (templateData.switchCheckBoxValue == 'on') {
        Vue.set(state.invoiceTemplateList[accountId + "-invoiceTemplateList"], 'subAccountsCanNotChangeInvoiceTemplate', 'Yes');
      } else {
        Vue.set(state.invoiceTemplateList[accountId + "-invoiceTemplateList"], 'subAccountsCanNotChangeInvoiceTemplate', 'No');
      }
    } else if (templateData.type == 'receipt_template') {
      if (templateData.switchCheckBoxValue == 'on') {
        Vue.set(state.receiptTemplateList[accountId + "-receiptTemplateList"], 'subAccountsCanNotChangeReceiptTemplate', 'Yes');
      } else {
        Vue.set(state.receiptTemplateList[accountId + "-receiptTemplateList"], 'subAccountsCanNotChangeReceiptTemplate', 'No');
      }
    } else if (templateData.type == 'credit_note_template') {
      if (templateData.switchCheckBoxValue == 'on') {
        Vue.set(state.creditNoteTemplateList[accountId + "-creditNoteTemplateList"], 'subAccountsCanNotChangeCreditNoteTemplate', 'Yes');
      } else {
        Vue.set(state.creditNoteTemplateList[accountId + "-creditNoteTemplateList"], 'subAccountsCanNotChangeCreditNoteTemplate', 'No');
      }
    } else if (templateData.type == 'caf_template') {
      if (templateData.switchCheckBoxValue == 'on') {
        Vue.set(state.cafTemplateList[accountId + "-cafTemplateList"], 'subAccountsCanNotChangeCafTemplate', 'Yes');
      } else {
        Vue.set(state.cafTemplateList[accountId + "-cafTemplateList"], 'subAccountsCanNotChangeCafTemplate', 'No');
      }
    } else if (templateData.type == 'franchise_invoice_template') {
      if (templateData.switchCheckBoxValue == 'on') {
        Vue.set(state.franchiseInvoiceTemplateList[accountId + "-franchiseInvoiceTemplateList"], 'subAccountsCanNotChangeFranchiseInvoiceTemplate', 'Yes');
      } else {
        Vue.set(state.franchiseInvoiceTemplateList[accountId + "-franchiseInvoiceTemplateList"], 'subAccountsCanNotChangeFranchiseInvoiceTemplate', 'No');
      }
    }
  },
  SET_RECEIPT_TEMPLATE_DETAILS(state, receiptTemplateData) {
    var tData = {};
    var parseData = receiptTemplateData.message;
    if (Object.keys(state.receiptTemplateList).length == 0) {
      tData[receiptTemplateData.accountId + '-receiptTemplateList'] = parseData;
      state.receiptTemplateList = tData;
    } else {
      Vue.set(state.receiptTemplateList, receiptTemplateData.accountId + '-receiptTemplateList', parseData);
    }
  },
  ADD_EDIT_RECEIPT_TEMPLATE_LIST(state, data) {
    var templates = data.templates;
    var accountId = data.accountId;
    Vue.set(state.receiptTemplateList[accountId + '-receiptTemplateList'], 'templates', templates);
  },
  DELETE_RECEIPT_TEMPLATE_LIST(state, data) {
    var receiptTemplateName = data.receiptData;
    var accountId = data.accountId;
    if (Object.keys(state.receiptTemplateList).length != 0) {
      var index = state.receiptTemplateList[accountId + "-receiptTemplateList"].templates.findIndex(receiptTemplate => receiptTemplate.receiptTemplateName == receiptTemplateName);
      if (index != '-1') {
        state.receiptTemplateList[accountId + "-receiptTemplateList"].templates.splice(index, 1)
      }
    }
  },
  SET_CREDIT_NOTE_TEMPLATE_DETAILS(state, creditNoteTemplateData) {
    var tData = {};
    var parseData = creditNoteTemplateData.message;
    if (Object.keys(state.creditNoteTemplateList).length == 0) {
      tData[creditNoteTemplateData.accountId + '-creditNoteTemplateList'] = parseData;
      state.creditNoteTemplateList = tData;
    } else {
      Vue.set(state.creditNoteTemplateList, creditNoteTemplateData.accountId + '-creditNoteTemplateList', parseData);
    }
  },
  DELETE_CREDIT_NOTE_TEMPLATE_LIST(state, data) {
    var creditNoteTemplateName = data.creditNoteData;
    var accountId = data.accountId;
    if (Object.keys(state.creditNoteTemplateList).length != 0) {
      var index = state.creditNoteTemplateList[accountId + "-creditNoteTemplateList"].templates.findIndex(creditNameTemplate => creditNameTemplate.creditNoteTemplateName == creditNoteTemplateName);
      if (index != '-1') {
        state.creditNoteTemplateList[accountId + "-creditNoteTemplateList"].templates.splice(index, 1)
      }
    }
  },
  ADD_EDIT_CREDIT_NOTE_TEMPLATE_LIST(state, data) {
    var templates = data.templates;
    var accountId = data.accountId;
    Vue.set(state.creditNoteTemplateList[accountId + '-creditNoteTemplateList'], 'templates', templates);
  },
  SET_CAF_TEMPLATE_DETAILS(state, cafTemplateData) {
    var tData = {};
    var parseData = cafTemplateData.message;
    if (Object.keys(state.cafTemplateList).length == 0) {
      tData[cafTemplateData.accountId + '-cafTemplateList'] = parseData;
      state.cafTemplateList = tData;
    } else {
      Vue.set(state.cafTemplateList, cafTemplateData.accountId + '-cafTemplateList', parseData);
    }
  },
  DELETE_CAF_TEMPLATE_LIST(state, data) {
    var cafTemplateName = data.cafData;
    var accountId = data.accountId;
    if (Object.keys(state.cafTemplateList).length != 0) {
      var index = state.cafTemplateList[accountId + "-cafTemplateList"].templates.findIndex(cafNameTemplate => cafNameTemplate.cafTemplateName == cafTemplateName);
      if (index != '-1') {
        state.cafTemplateList[accountId + "-cafTemplateList"].templates.splice(index, 1)
      }
    }
  },
  ADD_EDIT_CAF_TEMPLATE_LIST(state, data) {
    var templates = data.templates;
    var accountId = data.accountId;
    Vue.set(state.cafTemplateList[accountId + '-cafTemplateList'], 'templates', templates);
  },
  SET_FRANCHISE_INVOICE_TEMPLATE_DETAILS(state, franchiseInvoiceTemplateData) {
    var tData = {};
    var parseData = franchiseInvoiceTemplateData.message;
    if (Object.keys(state.franchiseInvoiceTemplateList).length == 0) {
      tData[franchiseInvoiceTemplateData.accountId + '-franchiseInvoiceTemplateList'] = parseData;
      state.franchiseInvoiceTemplateList = tData;
    } else {
      Vue.set(state.franchiseInvoiceTemplateList, franchiseInvoiceTemplateData.accountId + '-franchiseInvoiceTemplateList', parseData);
    }
  },
  DELETE_FRANCHISE_INVOICE_TEMPLATE_LIST(state, data) {
    var franchiseInvoiceTemplateName = data.franchiseInvoiceData;
    var accountId = data.accountId;
    if (Object.keys(state.franchiseInvoiceTemplateList).length != 0) {
      var index = state.franchiseInvoiceTemplateList[accountId + "-franchiseInvoiceTemplateList"].templates.findIndex(franchiseInvoiceNameTemplate => franchiseInvoiceNameTemplate.franchiseInvoiceTemplateName == franchiseInvoiceTemplateName);
      if (index != '-1') {
        state.franchiseInvoiceTemplateList[accountId + "-franchiseInvoiceTemplateList"].templates.splice(index, 1)
      }
    }
  },
  ADD_EDIT_FRANCHISE_INVOICE_TEMPLATE_LIST(state, data) {
    var templates = data.templates;
    var accountId = data.accountId;
    Vue.set(state.franchiseInvoiceTemplateList[accountId + '-franchiseInvoiceTemplateList'], 'templates', templates);
  },
  SET_INVOICE_DASHBOARD(state, data) {
    state.invoiceDashboard = data
  },
  SET_PAYMENT_DASHBOARD(state, data) {
    state.paymentDashboard = data
  },
  SOCKET_DELETEORDERPERCENTAGE(state, data) {
    state.deleteOrderLinePercentage = data
  },
  SOCKET_REPLACEORDERPERCENTAGE(state, data) {
    state.replaceOrderLinePercentage = data
  },
  SOCKET_DELETENORDERPERCENTAGE(state, data) {
    state.deletenOrderLinePercentage = data
  },
  SOCKET_ADDORDERPERCENTAGE(state, data) {
    state.addOrderPercentage = data
  },
  SOCKET_INVOICEPAIDPERCENTAGE(state, data) {
    state.invoicePaidPercent = data
  },
  SOCKET_UPDATEORDERLINEPERCENTAGE(state, data) {
    state.updateOrderLinePercentage = data
  },
}

const actions = {
  clearVoucherBasedBillingState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PAY_AS_YOU_GO_USER_STATE')
  },
  clearProductState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PRODUCT_STATE')
  },
  clearBillingState({
    commit,
    dispatch
  }) {
    commit('CLEAR_BILLING_STATE')
  },
  clearPlanState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PLAN_STATE')
  },
  clearOrderState({
    commit,
    dispatch
  }) {
    commit('CLEAR_ORDER_STATE')
  },
  clearPaymentState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PAYMENT_STATE')
  },
  fetchPinBillingDetail({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      Nprogress.start()
      axios.get('/pin_billing/index/' + true)
        .then(res => {
          Nprogress.done()
          console.log('Response : ', res);
          commit('SET_PIN_BILLING_LIST', res.data)
          resolve(res.data);

        })
        .catch(error => console.log(error))
    })
  },
  fetchProductDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/billing/products/true')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_PRODUCT_DETAILS', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  generatePinsModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/generate_pins', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getDetailsOfEditPins({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/pin_billing/edit_pin_groups/' + postData.groupid + '/true')
        .then(response => {
          console.log('response : ', response);
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getDetailsOfCreatePins({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/pin_billing/add_pin_group/true')
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  postDetailsOfEditPins({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/post_edit_pin_groups/' + postData.groupid, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  postDetailsOfCreatePins({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/add_pin_group', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deletePinsModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/delete_pingroup/' + postData.groupid, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditProductModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/create_product', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            productdata: response.data.productId,
            accountId: postData.accountId
          }
          if (!postData.fromProfile) {
            commit('ADD_PRODUCT_LIST', dataList);
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  autoRenewModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_auto_renewal_option', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            value: postData.value,
            accountId: postData.accountIdVal,
            userId: postData.pk
          }
          commit('CHANGE_BALACE_VALUE', dataList);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  allAutoRenewModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_auto_renewal_all_option', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createProductModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/create_product_category', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            productdata: response.data.productCategoryId,
            accountId: postData.accountId
          }
          commit('ADD_PRODUCT_CATEGORY_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteProductModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_product', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            productIds: response.data.productIds,
            accountId: postData.accountId
          }
          commit('DELETE_PRODUCT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAllProductModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_all_product', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            productIds: response.data.productIds,
            productCategoryIds: response.data.productCategoryIds,
            accountId: postData.accountId
          }
          commit('DELETE_PRODUCT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getPinDetailsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/get_pin_details.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  pushProductToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/push_all_products', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportProductSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/export_products_tally', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchAllPinsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/pin_billing/view_full_data/' + authData.accountId + "/" + authData.status + "/" + true + "/" + authData.limit + "/" + authData.page + "/" + authData.search + "/" + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_ALL_PINS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserStaticIpBillingList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/static_ip_billing/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_STATIC_IP_BILLING_LIST', res.data)
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserIptvBillingList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/iptv_billing/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_IPTV_BILLING_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserVoicePhoneBillingList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/ipphone_billing/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_VOICE_PHONE_BILLING_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserOttBillingList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/ott_billing/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_OTT_BILLING_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      // axios.get('/users/user_logs_data/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
      axios.post('/users/user_logs_data', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_LOGS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchEventLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/event_logs_data/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.type + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_Event_LOGS_LIST', res.data)
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchSmsLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/sms_logs_data/' + authData.userId + "/" + authData.accountId + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_SMS_LOGS_LIST', res.data)
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchWhatsappLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/whatsapp_logs_data/' + authData.userId + "/" + authData.accountId + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_SMS_LOGS_LIST', res.data)
          }
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchEmailLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/email_logs_data/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_EMAIL_LOGS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchPaymentLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/payment_logs_data/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_PAYMENT_LOGS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserRenewalLogsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_renewal_logs_data/' + authData.userId + "/" + authData.accountId + "/" + authData.status + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          commit('SET_USER_RENEWAL_LOGS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  getPlanHistoryDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/user_plans/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_PLAN_HISTORY_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  getFupHistoryDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/fup_history/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_FUP_HISTORY_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchFupFiltersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/fup_data/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_FUP_FILTERS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchIpFiltersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/userIpDetails/' + authData.userId + "/" + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting + '/' + authData.endDateFrom + '/' + authData.endDateTo)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            // commit('SET_USER_FUP_FILTERS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  usageProfileModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/usage_profile', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchSubUsersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/sub_users/' + authData.userId + "/" + authData.accountId + "/" + true)
        .then(res => {
          Nprogress.done()
          commit('SET_SUB_USERS_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchOrdersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_orders', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_ORDER_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserOrdersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_orders/' + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.userId + "/" + authData.activeSinceDateFrom + "/" + authData.activeSinceDateTo + "/" + authData.activeUntilDateFrom + "/" + authData.activeUntilDateTo + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_ORDER_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  balanceDueUser({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/balance_due_orders', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchSubZoneDetails({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      axios.get('/billing/get_sub_zone_details/' + authData.accountId)
        .then(res => {
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  customerOrderNumberEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_customer_order_number', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            orderData: response.data.orderDetail,
            type: 'Customer Order Number',
            accountId: postData.name
          }
          commit('UPDATE_ORDER_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  customerOrderDateEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_customer_order_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            orderData: response.data.orderDetail,
            type: 'Customer Order Date',
            accountId: postData.name
          }
          commit('UPDATE_ORDER_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  creditNoteNumEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_credit_note_number', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            creNumData: response.data.returnData,
            type: 'Change CreditNote Numbers'
          }
          commit('UPDATE_CREDIT_NOTE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getOrderDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getOrderDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getInvoiceDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getInvoiceDetails.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getInvoicePayDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getInvoiceDetails.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getBillingIdDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/view_billing_process_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getInvoiceAssociatedPaymentDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getInvoiceAssociatedPaymentDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  invoiceNumberEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_invoice_numbers', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: response.data.invoicePayDetail,
            type: 'Change Invoice Numbers'
          }
          commit('UPDATE_INVOICEPAY_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  publicNumberEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_public_number', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: response.data.returnData,
            type: 'Change Invoice Numbers'
          }
          commit('UPDATE_INVOICE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  poNumberEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_po_number', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: response.data.returnData,
            type: 'Change Po Numbers'
          }
          commit('UPDATE_INVOICE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createdInvoiceDateEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_create_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: response.data.returnData,
            type: 'Created Date'
          }
          commit('UPDATE_INVOICE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createdPaymentDateEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_payment_created_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: {
              accountId: postData.accId,
              create_datetime: postData.value,
              id: postData.pk
            },
          }
          commit('UPDATE_PAYMENT_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createdDateEdit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/edit_create_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            invoicePayData: response.data.invoicePayDetail,
            type: 'Created Date'
          }
          commit('UPDATE_INVOICEPAY_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteOrderSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader
      if (!postData.socketData) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/billing/delete_order', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          if (!postData.socketData) {
            loader.hide()
          }
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            orderIds: response.data.orderIds,
            accountId: postData.listAccountId
          }
          commit('DELETE_ORDER_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  updateOrderSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/update_order_lines', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createOrderBillPlanSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/create_order_for_all_user', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  addOrderLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader;
      if (!postData.socketData) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/billing/add_order_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          if (!postData.socketData) {
            loader.hide()
          }
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            orderIds: response.data.orderIds,
            accountId: postData.accountId
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  applyOrderToIPPhoneBilling({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/applyOrderToIPPhoneBilling', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  applyOrderToOttBilling({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/applyOrderToOttBilling', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addOrderToIptvBilling({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/applyOrderToIPTVBilling', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  replaceOrderLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader
      if (!postData.socketData) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/billing/replace_billing_order_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          if (!postData.socketData) {
            loader.hide()

          }
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            orderIds: response.data.orderIds,
            accountId: postData.accountId
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteOrderLineall({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_billing_order_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            orderIds: response.data.orderIds,
            accountId: postData.accountId
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, deleteOrderLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      var loader
      if (!postData.socketValue) {
        loader = Vue.$loading.show({
          canCancel: false,
        });
      }
      axios.post('/users/delete_order_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          if (!postData.socketValue) {
            loader.hide()
          }
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createOrderModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/create_orders', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (postData.actionType != 'add_line') {
            var dataList = {
              orderdata: response.data.orderId,
              accountId: response.data.currentAccountId
            }
            commit('UPDATE_SINGLE_ORDER_LIST', dataList)
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  editBillingCycle({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/order_billing_cycle_change', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            orderData: response.data.orderDetail,
            type: "Billing Cycle",
            accountId: postData.billingAccountId
          }
          console.log("0", dataList);
          commit('UPDATE_ORDER_LIST', dataList)
          console.log("1", dataList);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchProformaInvoicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_proforma_invoices', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_PROFORMA_INVOICE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserProformaInvoicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_proforma_invoices/' + authData.accountId + "/" + authData.status + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.userId + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_PROFORMA_INVOICE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchInvoicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_invoices', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_INVOICE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserInvoicesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_invoices/' + authData.accountId + "/" + authData.status + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.userId + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_INVOICE_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserCreditNotesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_credit_notes/' + authData.accountId + "/" + authData.activeSinceDate + "/" + authData.activeUntilDate + "/" + authData.userId + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_CREDIT_NOTES_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchCreditNotesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_credit_notes', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_CREDIT_NOTES_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchInvoicesPayList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_invoices_associated_with_payments', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_INVOICE_PAY_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUsersInvoicesPayList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_invoices_associated_with_payments/' + authData.userId + "/" + authData.accountId + "/" + authData.status + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + null + "/" + null + '/' + null + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_INVOICE_PAY_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchCompletedSessionsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/session_data/' + authData.userId + "/" + authData.accountId + "/" + false + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + false + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_COMPLETED_USER_SESSIONS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  getRate({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/rate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });
  },
  fetchSessionsDayWiseList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/session_data/' + authData.userId + "/" + authData.accountId + "/" + true + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + false + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_USER_TRAFFIC_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  terminateSession({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/monitoring/terminate_session', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });
  },
  activeUserSession({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/rate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });
  },
  fetchScheduleRenewalsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_schedule_renewals', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_SCHEDULED_RENEWALS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchRenewalSummaryList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/billing/get_all_renewals_summary/' + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_RENEWAL_SUMMARY_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchBillingConfigList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/billing/get_all_billing_process/' + authData.accountId + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_BILLING_CONFIG_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  getDiagnosticsTableDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/view_report', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });

  },
  getImportTableDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/check_users', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });

  },
  setNextBillingDate({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_billing_run_date', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.status != 'success') {
            reject(response.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });

  },
  getRenewalTableDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/get_renewal_details', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })

        .catch(error => console.log(error))
    });

  },
  sendInvoicePayEmailSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/mail_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            if (response.data.status == null || response.data.status == "") {
              reject("Unable to dispatch E-mail.Check for E-mail template disable.");
            } else {
              reject(response.data.genericBody);
            }
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  downloadInvoicePaySubmit({
    commit,
    dispatch
  }, postData) {
    let loader = Vue.$loading.show({
      canCancel: false,
    });
    axios.post('/users/download_invoice', qs.stringify(postData, {
      parseArrays: false
    }))
      .then(response => {
        loader.hide()
        if (response.data.status != 'success') {
          return;
        }
        window.open("/backend" + response.data.message);
      })
      .catch(error => console.log(error));
  },
  increaseInvoiceLineQuantity({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/increase_or_decrease_invoice_line_quantity', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteInvoiceLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_invoice_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }
          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  updateStaticIpList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/update_static_ip', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            staticIpDetails: response.data.staticIpDetails,
            accountId: postData.accountId
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_billing_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceIds: response.data.invoiceIds,
            accountId: postData.listAccountId
          }

          ///commit('DELETE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  removeGracePeriodModalSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/remove', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          console.log(postData);
          var successData = {
            userDetails: response.data.userDetails,
            accountId: postData.accountId
          }
          commit('UPDATE_EXPIRY_REMOVE', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  deleteScheduledRenewalModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });

      axios.post('/billing/delete_schedule_renewal_all', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;

          }
          var successData = {
            execId: postData.execId,
            accountId: postData.accountId
          }

          commit('DELETE_SCHEDULED_RENEWALS_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteScheduledRenewalsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_schedule_renewal', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          var successData = {
            execId: postData.execId,
            accountId: postData.accountId
          }

          commit('DELETE_SCHEDULED_RENEWALS_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  startScheduleRenewalModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/schedule_renewal_start', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            execId: postData.execId,
            accountId: postData.accountId
          }

          // commit('UPDATE_SCHEDULED_RENEWALS_LIST', successData);

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteCreditNoteModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_credit_notes', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceIds: postData.userIds,
            accountId: response.data.currentAccountId
          }
          resolve(response.data);
          commit('DELETE_CREDIT_NOTES_LIST', successData);
        })
        .catch(error => console.log(error));
    });
  },
  deleteProformaInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_billing_proforma_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceIds: response.data.invoiceIds,
            accountId: postData.accountId
          }

          commit('DELETE_PROFORMA_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  regenerateInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/regenerate_invoices', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  generateInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      if (postData.method == "generate_proforma_invoice_from_order") {
        axios.post('/users/generate_proforma_invoice_from_order', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            resolve(response.data);
          })
          .catch(error => console.log(error));
      } else {
        axios.post('/users/generate_invoice_from_order', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            var successData = {
              orderData: response.data.orderId,
              accountId: postData.currentAccountId,
              type: "Generate Invoice From Order"
            }
            commit('UPDATE_ORDER_LIST', successData);
            resolve(response.data);
          })
          .catch(error => console.log(error));
      }

    });
  },
  generateOldInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/generate_old_invoice_from_order', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  applyToInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/applyInvoiceToSelected', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  sendInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      if (postData.sendType == 'mail') {
        axios.post('/billing/send_all_invoices', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            resolve(response.data);
          })
          .catch(error => console.log(error));
      } else {
        axios.post('/billing/send_all_sms_invoices', qs.stringify(postData, {
          parseArrays: false
        }))
          .then(response => {
            loader.hide()
            if (response.data.status != 'success') {
              reject(response.data.message);
              return;
            }
            resolve(response.data);
          })
          .catch(error => console.log(error));
      }
    });
  },
  sendInvoiceEmailSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/mail_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            if (response.data.status == null || response.data.status == "") {
              reject("Unable to dispatch E-mail.Check for E-mail template disable.");
            } else {
              reject(response.data.message);
            }

            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  sendInvoiceSmsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/sms_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            if (response.data.status == null || response.data.status == "") {
              reject("Unable to dispatch SMS.Check for SMS template disable.");
            } else {
              reject(response.data.message);
            }

            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  sendProformaInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/send_all_proforma_invoices', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  payInvoiceSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      // axios.post('/users/make_user_payment', qs.stringify(postData, {
      //   parseArrays: false
      // }))
      axios.post('/users/make_user_payment', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  usePinModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/pin_valid', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  payInvoiceLeadSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      // axios.post('/lead_management/make_lead_payment', qs.stringify(postData, {
      //    parseArrays: false
      //  }))
      axios.post('/lead_management/make_lead_payment', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  makeMultiplePaymentInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/make_billing_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: postData.listAccountId
          }

          resolve(response.data);
          commit('UPDATE_INVOICES_LIST', successData);
        })
        .catch(error => console.log(error));
    });
  },
  downloadInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/download_all_invoices', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var filePath = response.data.message.host + '/' + response.data.message.filePath;
          window.open(filePath);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  downloadInvoiceSubmit({
    commit,
    dispatch
  }, postData) {

    let loader = Vue.$loading.show({
      canCancel: false,
    });
    axios.post('/users/download_invoice', qs.stringify(postData, {
      parseArrays: false
    }))
      .then(response => {
        loader.hide()
        if (response.data.status != 'success') {
          return;
        }
        if (postData.mobileView == "mobile") {
          window.open(response.data.mailAttachment);
          return;
        }
        window.open("/backend" + response.data.message);
      })
      .catch(error => console.log(error));
  },

  downloadSingleProformaInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {

    let loader = Vue.$loading.show({
      canCancel: false,
    });
    axios.post('/users/download_proforma_invoice', qs.stringify(postData, {
      parseArrays: false
    }))
      .then(response => {
        loader.hide()
        if (response.data.status != 'success') {
          return;
        }
        window.open("/backend" + response.data.message);
      })
      .catch(error => console.log(error));
  },

  downloadProformaInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/download_all_proforma_invoices', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var filePath = response.data.message.host + '/' + response.data.message.filePath;
          window.open(filePath);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  downloadCreditNotesModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/download_credit_note', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var filePath = "/backend" + response.data.message;
          window.open(filePath);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },


  viewCreditNotesModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getCreditNoteDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  paymentDetailsModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/logs/getPaymentLogDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  reVerifyTransactionDetailsModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/logs/reVerifyTransactionStatus', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          // if (response.data.status != 'success') {
          //   reject(response.data.message);
          //   return;
          // }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getPayProformaInvoicesDetailsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getInvoiceDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  getProformaInvoicesDetailsSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getProformaInvoiceDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  convertProformaInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/convert_proformato_original_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
        })
        .catch(error => console.log(error));
    });
  },


  exportLedgerInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/master_ledger', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportTallyInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/export_to_tally', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportLedgerPaymentModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/master_ledger_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportTallyPaymentModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/export_payment_to_tally', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  changeInvoiceNumberModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/change_invoice_numbers', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  creditNoteInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/credit_note_billing_invoice', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status == 'error') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.currentAccountId
          }
          commit('UPDATE_INVOICES_LIST', successData);
        })
        .catch(error => console.log(error));
    });
  },
  quickbookInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/quickbook_sync', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  iptvInvoiceModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/iptv/send_iptv_message', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchPaymentsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_payments', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_PAYMENT_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchUserPaymentsList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.get('/users/get_all_user_payments/' + authData.accountId + "/" + authData.customDateFrom + "/" + authData.customDateTo + "/" + authData.userId + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_PAYMENT_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },

  fetchVoucherNotesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/user_billing_type_data', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_VOUCHER_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },

  fetchGracePeriodUsersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/user_grace_period_data', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_GRACE_PERIOD_USERS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchPayLaterUsersList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/user_grace_period_prepaid_data', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_PAY_LATER_USERS_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchStaticIpsBillingList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/billing/get_all_static_ip_billing', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push("/dashboard");
          } else {
            commit('SET_STATIC_IPS_BILLING_LIST', res.data)
            resolve(res.data);
          }
        })
        .catch(error => console.log(error))
    });
  },
  fetchPinBunchView({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/pin_billing/view_pin_bunch_data/' + authData.bunchId, qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_PIN_BUNCH_VIEW_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  fetchPinBunchGroup({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    return new Promise((resolve, reject) => {
      axios.post('/pin_billing/view_bunch_groups', qs.stringify(authData, {
        parseArrays: false
      }))
        .then(res => {
          Nprogress.done()
          commit('SET_PIN_BUNCH_GROUP_LIST', res.data)
          resolve(res.data);
        })
        .catch(error => console.log(error))
    });
  },
  bunchDetailsSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/getBunchDetails.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  sellBunchModalSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/sell_pins.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            accountId: postData.presentAccId,
            updateStatus: response.data.updatedStatusOfThePins,

          }
          commit('UPDATE_STATUS_PINBUNCH', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportBunchSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/export_pins', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status == 'success') {
            resolve(response.data);
            window.open("/backend" + response.data.message);
          }
        })
        .catch(error => console.log(error));
    });
  },
  destroyBunchModalSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/delete_pins.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            accountId: postData.presentAccId,
            bunchId: postData.bunchId,

          }
          commit('DESTROY_PIN_BUNCH', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteBunchModalSubmit({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/pin_billing/delete_bunch', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            accountId: postData.presentAccId,
            bunchId: postData.bunchId,

          }
          commit('DELETE_PIN_BUNCH', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createStaticIpBilling({
    commit, }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/helpdesk/create_staticIP_billing', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            userDetails: response.data.userDetails,
            accountId: postData.accountName
          }
          commit('CREATE_STATICIP_BILLING', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  downloadPaymentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/download_receipt', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          window.open("/backend" + response.data.message);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  sendPaymentEmailSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/mail_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getPaymentDetails({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/getPaymentDetails', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deletePaymentModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_billing_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            paymentIds: response.data.paymentIds,
            accountId: postData.listAccountId
          }

          commit('DELETE_PAYMENT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  unlinkUserSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var accountID = postData.accountID;
      axios.post('/users/unlink_sub_user/' + accountID, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            accountId: postData.accountID,
            userDetails: response.data.userDetails
          }
          commit('DELETE_SUBUSER_LIST', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getSubUserNameList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var accountID = postData.accountID;
      var userId = postData.userId;
      axios.post('/users/get_account_users/' + userId + '/' + accountID, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            message: response.data.message,
            accountId: postData.accountID
          }
          commit('LINK_SUBUSER_LIST', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  linkUserSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var accountID = postData.accountID;
      axios.post('/users/sub_users/null/' + accountID + "/false", qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            accountId: postData.accountID,
            userDetails: response.data.userDetails
          }
          commit('ADD_SUBUSER_LIST', data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addIpPhoneSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_ipphone_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addOttSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_ott_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addIptvSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_iptv_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addStaticIpSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/add_static_ip_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteIpPhoneBillingSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_ipphone_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteOttBillingSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_ott_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteIptvBillingSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_iptv_in_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteStaticIpSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/delete_static_ip_billing_cycle', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  closeIpPhoneSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/closeOrderToSelectedIpphone', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  closeIptvSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/closeOrderToSelectedIptv', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  closeOttSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/closeOrderToSelectedOtt', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  closeStaticIpSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/closeOrderToSelectedIp', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addOrderSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/users/applyOrderToSelectedIp', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  linkPaymentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/link_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  increaseInvoiceLineQuantity({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/increase_or_decrease_invoice_line_quantity', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, deleteInvoiceLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_invoice_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, addInvoiceLine({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_invoice_line', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, unlinkPaymentSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/unlink_payment', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceData,
            accountId: response.data.presentAccountId
          }

          commit('UPDATE_INVOICES_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  fetchPlanDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/billing/plans/true')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_PLAN_DETAILS', res.data)
        }

      })
      .catch(error => console.log(error))
  },
  createPlanModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/create_plan', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            planData: response.data.billPlanData,
            accountId: response.data.account_id
          }

          commit('ADD_BILL_PLAN_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteAllPlanModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_plan', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            planIds: response.data.planIds,
            accountId: postData.accountId
          }
          commit('DELETE_PLAN_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deletePlanOrderModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/delete_plan_order', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            if (response.data.message == "") {
              reject(response.data.genericBody);
            } else {
              reject(response.data.message);
            }
            return;
          }
          var successData = {
            planIds: response.data.planPolicyIds,
            accountId: postData.accountId
          }
          commit('DELETE_PLAN_POLICY_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  createPlanOrderModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/create_plan_products', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            planData: response.data.billPlanPolicyData,
            accountId: response.data.account_id,
            planId: postData.planId,
            method: 'create'
          }

          commit('ADD_PLAN_POLICY_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  getPlanTableData({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      axios.get('/billing/get_plan_products_data/' + authData.billPlans)
        .then(response => {
          var successData = {
            planData: response.data.billPlanPolicyData,
            accountId: response.data.account_id,
            method: 'display'
          }
          commit('ADD_PLAN_POLICY_LIST', successData);
        })
        .catch(error => console.log(error))
    });
  },
  getPlanProductCategories({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      axios.get('/billing/get_product_and_categories/null/true')
        .then(response => {
          commit('UPDATE_PLAN_PRODUCT_CATEGORIES', response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error))
    });
  },
  replaceProductSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/replace_product', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.genericBody);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importPlanModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/import_plans_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          // commit('ADD_BILL_PLAN_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importPlanCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/import_plans_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          // commit('ADD_BILL_PLAN_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  exportPlanSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/export_plans_csv', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchNotificationDetails({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get(authData.url)
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_NOTIFICATION_DETAILS', res.data)
        }

      })
      .catch(error => console.log(error))
  },
  saveBillingNotifications({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post(postData.url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.alertText);
        })
        .catch(error => console.log(error));
    });
  },
  addNotificationToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/notifications/add_notifications_to_all_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  saveSubAccountNotificationSettings({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/notifications/save_sub_accounts_cannot_change_notifications', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SET_RESTRICTION_CHECKBOX_VALUE', postData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInvoiceTemplateList({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/billing/invoice_template/true")
      .then(response => {
        Nprogress.done()
        if (response.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_INVOICE_TEMPLATE_DETAILS', response.data)
        }
      })
      .catch(error => console.log(error))
  },
  makeDefaultInvoiceTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/make_default_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteInvoiceTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/delete_invoice_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            invoiceData: response.data.invoiceTemplateName,
            accountId: response.data.accountId
          }
          commit('DELETE_INVOICE_TEMPLATE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditInvoiceTemplateSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/invoiceTemplateSubmit', postData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            templates: response.data.templates,
            accountId: response.data.accountId
          }
          commit('ADD_EDIT_INVOICE_TEMPLATE_LIST', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  saveSubAccountPermissionInvoiceTemplateSettings({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/save_sub_accounts_cannot_change_templates', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit('SET_TEMPLATE_CHECKBOX_VALUE', postData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  addInvoiceTemplateToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_invoicetemplate_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchReceiptTemplateList({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/billing/receipt_template/true")
      .then(response => {
        Nprogress.done()
        if (response.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_RECEIPT_TEMPLATE_DETAILS', response.data)
        }
      })
      .catch(error => console.log(error))
  },
  makeDefaultReceiptTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/make_default_receipt_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteReceiptTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/delete_receipt_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            receiptData: response.data.receiptTemplateName,
            accountId: response.data.accountId
          }
          commit('DELETE_RECEIPT_TEMPLATE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditReceiptTemplateSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/receiptTemplateSubmit', postData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            templates: response.data.templates,
            accountId: response.data.accountId
          }
          commit('ADD_EDIT_RECEIPT_TEMPLATE_LIST', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addReceiptTemplateToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_receipttemplate_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchCreditNoteTemplateList({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/billing/credit_note_template/true")
      .then(response => {
        Nprogress.done()
        if (response.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_CREDIT_NOTE_TEMPLATE_DETAILS', response.data)
        }
      })
      .catch(error => console.log(error))
  },
  makeDefaultCreditNoteTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/make_default_credit_note_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },

  deleteCreditNoteTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/delete_credit_note_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            creditNoteData: response.data.creditNoteTemplateName,
            accountId: response.data.accountId
          }
          commit('DELETE_CREDIT_NOTE_TEMPLATE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditCreditNoteTemplateSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/creditNoteTemplateSubmit', postData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            templates: response.data.templates,
            accountId: response.data.accountId
          }
          commit('ADD_EDIT_CREDIT_NOTE_TEMPLATE_LIST', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addCreditNoteTemplateToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_credit_note_template_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchCAFTemplateList({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/billing/caf_template/true")
      .then(response => {
        Nprogress.done()
        if (response.data.status == "redirect") {
          router.push("/dashboard");
        } else {
          commit('SET_CAF_TEMPLATE_DETAILS', response.data)
        }
      })
      .catch(error => console.log(error))
  },
  makeDefaultCAFTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/make_default_caf_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteCAFTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/delete_caf_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            cafData: response.data.cafTemplateName,
            accountId: response.data.accountId
          }
          commit('DELETE_CAF_TEMPLATE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditCAFTemplateSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/cafTemplateSubmit', postData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            templates: response.data.templates,
            accountId: response.data.accountId
          }
          commit('ADD_EDIT_CAF_TEMPLATE_LIST', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addCAFTemplateToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_caftemplate_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchFranchiseInvoiceTemplateList({
    commit
  }, authData) {
    Nprogress.start()
    axios.get("/billing/franchise_invoice_template/true")
      .then(response => {
        Nprogress.done()
        commit('SET_FRANCHISE_INVOICE_TEMPLATE_DETAILS', response.data)
      })
      .catch(error => console.log(error))
  },
  makeDefaultFranchiseInvoiceTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/make_default_franchise_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteFranchiseInvoiceTemplateSubmit({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/billing/delete_franchise_invoice_template/' + authData.gatewayId)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            franchiseInvoiceData: response.data.franchiseInvoiceTemplateName,
            accountId: response.data.accountId
          }
          commit('DELETE_FRANCHISE_INVOICE_TEMPLATE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditFranchiseInvoiceTemplateSubmit({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/franchiseInvoiceTemplateSubmit', postData)
        .then(response => {
          loader.hide();
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            templates: response.data.templates,
            accountId: response.data.accountId
          }
          commit('ADD_EDIT_FRANCHISE_INVOICE_TEMPLATE_LIST', successData);
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },

  addFranchiseInvoiceTemplateToAllSubZones({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/add_franchiseinvoicetemplate_subaccounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchInvoicesDashboard({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/billing/invoices_dashboard_list')
      .then(res => {
        Nprogress.done()
        commit('SET_INVOICE_DASHBOARD', res.data)
      })
      .catch(error => console.log(error))
  },
  fetchInvoicesDashboardPayments({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/invoice_dashboard_recentpayment/' + postData)
        .then(response => {
          loader.hide()
          resolve(response.data)
          console.log('vue resssssss 2', response)
          // if (response.data.status != 'success') {
          //   reject(response.data.message);
          //   return;
          // }
          // resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  fetchPaymentDashboard({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/billing/payment_dashboard_list')
      .then(res => {
        Nprogress.done()
        commit('SET_PAYMENT_DASHBOARD', res.data)
      })
      .catch(error => console.log(error))
  },
  fetchPaymentDashboardPayments({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/billing/payment_dashboard_recentpayment/' + postData)
        .then(response => {
          loader.hide()
          resolve(response.data)
          console.log('vue resssssss 2', response)
          // if (response.data.status != 'success') {
          //   reject(response.data.message);
          //   return;
          // }
          // resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  // palladiumInvoiceModalSubmit({
  //   commit,
  //   dispatch
  // }, postData) {
  //   return new Promise((resolve, reject) => {

  //     let loader = Vue.$loading.show({
  //       canCancel: false,
  //     });
  //     axios.post('/billing/palladium_sync', qs.stringify(postData, {
  //       parseArrays: false
  //     }))
  //       .then(response => {
  //         loader.hide()
  //         if (response.data.status != 'success') {
  //           reject(response.data.genericBody);
  //           return;
  //         }
  //         resolve(response.data);
  //       })
  //       .catch(error => console.log(error));
  //   });
  // },
}

const getters = {
  getPinBunchViewGetters: state => {
    return state.pinPunchViewList;
  },
  getPinBunchViewPermissionGetters: state => {
    return state.pinPunchViewPermission;
  },
  getPinBunchGroupGetters: state => {
    return state.pinPunchGroupList;
  },
  getPinBunchGroupPermissionGetters: state => {
    return state.pinPunchGroupPermission;
  },
  getAllPinsListGetters: state => {
    return state.allPinsList;
  },
  getAllPinsPermissionGetters: state => {
    return state.allPinsPermission;
  },
  getPinBillingListGetters: state => {
    return state.pinBillingList;
  },
  getPinBillingPermissionGetters: state => {
    return state.pinBillingPermission;
  },
  geUserVoicePhoneBillingListGetters: state => {
    return state.userVoicePhoneBillingList;
  },
  getUserVoicePhoneBillingPermissionGetters: state => {
    return state.userVoicePhoneBillingPermission;
  },
  geUserOttBillingListGetters: state => {
    return state.userOttBillingList;
  },
  getUserOttBillingPermissionGetters: state => {
    return state.userOttBillingPermission;
  },
  geUserIptvBillingListGetters: state => {
    return state.userIptvBillingList;
  },
  getUserIptvBillingPermissionGetters: state => {
    return state.userIptvBillingPermission;
  },
  getProductDetailsGetters: state => {
    return state.productDetails;
  },
  getOrdersListGetters: state => {
    return state.ordersList;
  },
  geUserStaticIpBillingListGetters: state => {
    return state.userStaticIpBillingList;
  },
  getUserLogsListGetters: state => {
    return state.userLogsList;
  },
  getUserLogsPermissionGetters: state => {
    return state.userLogsPermission;
  },
  getEventLogsListGetters: state => {
    return state.eventLogsList;
  },
  getEventLogsPermissionGetters: state => {
    return state.eventLogsPermission;
  },
  getSmsLogsListGetters: state => {
    return state.smsLogsList;
  },
  getSmsLogsPermissionGetters: state => {
    return state.smsLogsPermission;
  },
  getEmailLogsListGetters: state => {
    return state.emailLogsList;
  },
  getEmailLogsPermissionGetters: state => {
    return state.emailLogsPermission;
  },
  getPaymentLogsListGetters: state => {
    return state.paymentLogsList;
  },
  getPaymentLogsPermissionGetters: state => {
    return state.paymentLogsPermission;
  },

  getRenewalLogsListGetters: state => {
    return state.userRenewalLogsList;
  },
  getRenewalLogsPermissionGetters: state => {
    return state.userRenewalLogsPermission;
  },
  getFupFiltersListGetters: state => {
    return state.userFupFilterList;
  },
  getFupFiltersPermissionGetters: state => {
    return state.userFupFilterPermission;
  },
  getCompletedUserSessionsGetters: state => {
    return state.completedUserSessionsList;
  },
  getCompletedUserSessionsPermissionGetters: state => {
    return state.completedUserSessionsPermission;
  },
  getUserTrafficGetters: state => {
    return state.sessionsDayWiseList;
  },
  getUserTrafficPermissionGetters: state => {
    return state.sessionsDayWisePermission;
  },
  getOrdersPermissionGetters: state => {
    return state.ordersPermission;
  },
  getUserStaticIpBillingPermissionGetters: state => {
    return state.userStaticIpBillingPermission;
  },
  getSubUsersPermissionGetters: state => {
    return state.subUsersPermission;
  },
  getSubUsersListGetters: state => {
    return state.subUsersList;
  },
  getInvoicesListGetters: state => {
    return state.invoicesList;
  },
  getProformaInvoicesListGetters: state => {
    return state.proformaInvoicesList;
  },
  getCreditNotesListGetters: state => {
    return state.creditNotesList;
  },
  getVoucherListGetters: state => {
    return state.voucherList;
  },
  getGracePeriodListGetters: state => {
    return state.gracePeriodList;
  },
  getPayLaterUsersListGetters: state => {
    return state.payLaterUsersList;
  },
  getStaticIpsBillingListGetters: state => {
    return state.staticIpsBillingList;
  },
  getInvoicesPermissionGetters: state => {
    return state.invoicesPermission;
  },
  getProformaInvoicesPermissionGetters: state => {
    return state.proformaInvoicesPermission;
  },
  getCreditNotesPermissionGetters: state => {
    return state.creditNotesPermission;
  },
  getVoucherPermissionGetters: state => {
    return state.voucherPermission;
  },
  getGracePeriodPermissionGetters: state => {
    return state.gracePeriodPermission;
  },
  getPayLaterUsersPermissionGetters: state => {
    return state.payLaterUsersPermission;
  },
  getStaticIpsBillingPermissionGetters: state => {
    return state.staticIpsBillingPermission;
  },
  getPaymentsListGetters: state => {
    return state.paymentsList;
  },
  getPaymentsPermissionGetters: state => {
    return state.paymentsPermission;
  },
  getInvoicesAssociatePayListGetters: state => {
    return state.invoicesPayList;
  },
  getInvoiceAssociatePayPermissionGetters: state => {
    return state.invoicesPayPermission;
  },
  getScheduledRenewalsListGetters: state => {
    return state.scheduledRenewalsList;
  },
  getScheduledRenewalsPermissionGetters: state => {
    return state.scheduledRenewalsPermission;
  },
  getPlanDetailsGetters: state => {
    return state.planDetails;
  },
  getBillPlanGetters: state => {
    return state.billPlanList;
  },
  getPlanTableGetters: state => {
    return state.billPlanOrderList;
  },
  getRenewalSummaryListGetters: state => {
    return state.renewalSummaryList;
  },
  getPlanProductCategoriesGetters: state => {
    return state.billPlanProductCategoriesList;
  },
  getPlanProductsGetters: state => {
    return state.billPlanProductsList;
  },
  getPlanPeriodsGetters: state => {
    return state.billPlanPeriodsList;
  },
  getPlanPermissionGetters: state => {
    return state.billPlanPermissionList;
  },
  getBillingConfigListGetters: state => {
    return state.billingConfigList;
  },
  getBillingConfigPermissionGetters: state => {
    return state.billingConfigPermission;
  },
  getNotificationDetailsGetter: state => {
    return state.notificationDetails;
  },
  getInvoiceTemplateListGetter: state => {
    return state.invoiceTemplateList;
  },
  getReceiptTemplateListGetter: state => {
    return state.receiptTemplateList;
  },
  getCreditNoteTemplateListGetter: state => {
    return state.creditNoteTemplateList;
  },
  getCAFTemplateListGetter: state => {
    return state.cafTemplateList;
  },
  getFranchiseInvoiceTemplateListGetter: state => {
    return state.franchiseInvoiceTemplateList;
  },
  getInvoicesDashboardGetter: state => {
    return state.invoiceDashboard;
  },
  getPaymentDashboardGetter: state => {
    return state.paymentDashboard;
  },
  socketDeleteOrderUpdate: state => {
    return state.deleteOrderLinePercentage
  },
  socketReplaceOrderUpdate: state => {
    return state.replaceOrderLinePercentage
  },
  socketDeleteNOrderUpdate: state => {
    return state.deletenOrderLinePercentage
  },
  socketaddOrderUpdate: state => {
    return state.addOrderPercentage
  },
  socketPaidInvoiceUpdate: state => {
    return state.invoicePaidPercent
  },
  socketUpdateOrderLineUpdate: state => {
    return state.updateOrderLinePercentage
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
